module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av451-8b06763210e469a605ecbe5e31c6a267.jpg";